import { DatePicker, SegmentedControl, Select, Input } from '@bitcine/cinesend-theme'
import { useEffect, useState } from 'react'
import useStore from '../../hooks/use_store'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { humanFileSize } from '../../helpers/human_file_size'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'

const Details = ({ cycle }) => {
  const { updateModel } = useStore()
  const [state, setState] = useState(cycle)
  const updateState = (data) => setState({ ...state, ...data })
  const queryClient = useQueryClient()
  const { canEditModel: canEditCycle } = useAuth(modelTypes.Cycle, cycle)

  const saveModel = (data) => {
    updateModel.mutate(
      {
        endpoint: 'cycles',
        id: cycle.id,
        data,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['cycles/'])
        },
      }
    )
  }
  const updateField = (data) => {
    updateState(data)
    saveModel(data)
  }
  const { data, isLoading } = useQuery(['schemas'])
  const schemaOptions = data ? data.data.map((schema) => ({ value: schema.id, label: schema.name })) : []

  const disabled = !canEditCycle
  return (
    <div className='grid grid-cols-2 xl:grid-cols-4 gap-3 gap-y-4'>
      <DatePicker
        useLocal={false}
        label='Cycle Start Date'
        date={state.start_date}
        showTimeSelect={false}
        onChange={(date) => updateField({ start_date: date })}
        disabled={disabled}
      />
      <DatePicker
        useLocal={false}
        label='Cycle End Date'
        date={state.end_date}
        showTimeSelect={false}
        onChange={(date) => updateField({ end_date: date })}
        disabled={disabled}
      />
      <Select
        label='Schema'
        value={schemaOptions.find((opt) => opt.value === state.schema_id)}
        isLoading={isLoading}
        options={schemaOptions}
        onChange={(opt) => updateField({ schema_id: opt.value })}
        disabled={disabled}
      />
      {cycle.status !== 'Future' && (
        <SegmentedControl
          label='Cycle status'
          size='small'
          options={[
            { label: 'Open', value: 'open' },
            { label: 'Closed', value: 'closed' },
          ]}
          value={state.is_locked ? 'closed' : 'open'}
          onChange={(value) => {
            const id =
              value === 'closed' ? `${cycle.id}/close` : `${cycle.id}/open${cycle.status === 'Closed' ? '?reopen' : ''}`
            updateModel.mutate(
              { endpoint: 'cycles', id },
              {
                onSuccess: () => {
                  updateState({ is_locked: value === 'closed' })
                  queryClient.invalidateQueries(['cycles/'])
                },
              }
            )
          }}
          disabled={disabled}
        />
      )}
      {/* <Button onClick={() => navigate(`/schemas/${cycle.schema_id}`)}>
        View Schema Definition
      </Button>
      <Button onClick={() => createModel.mutate({
          endpoint: 'schemas',
          data: {
            schemaID: cycle.schema_id
          }
        })}>
        Create New Schema
      </Button> */}
    </div>
  )
}

export default Details
